exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Xr0eaJ6i4PjMijlZ1K5nB{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);
// Exports
exports.locals = {
	"projectionSxSV2": "_3Xr0eaJ6i4PjMijlZ1K5nB"
};